import { render, staticRenderFns } from "./BaseItem.vue?vue&type=template&id=300ea5f4&"
import script from "./BaseItem.vue?vue&type=script&lang=js&"
export * from "./BaseItem.vue?vue&type=script&lang=js&"
import style0 from "./BaseItem.vue?vue&type=style&index=0&id=300ea5f4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports